import React from "react";
import { ThemeProvider } from "./contexts/ThemeContext";
import ParticleBackground from "./components/particles/ParticleBackground";
import ThemeToggle from "./components/theme/ThemeToggle";
import Banner from "./components/banner/Banner";
import Contact from "./components/contact/Contact";
import Features from "./components/features/Features";
import Footer from "./components/footer/Footer";
import FooterBottom from "./components/footer/FooterBottom";
import Navbar from "./components/navbar/Navbar";
import Projects from "./components/projects/Projects";
import Resume from "./components/resume/Resume";
import Testimonial from "./components/tesimonial/Testimonial";
import ScrollToTop from "./components/layouts/ScrollToTop";
import CombinedEffects from "./components/effects/CombinedEffects";

function App() {
  return (
    <ThemeProvider>
      <div className="w-full h-auto bg-bodyColor text-lightText px-4 relative">
        <ParticleBackground />
        <CombinedEffects />
        <ThemeToggle />
        <Navbar />
        <div className="max-w-screen-xl mx-auto relative z-10">
          <Banner />
          <Features />
          <Projects />
          <Resume />
          <Testimonial />
          <Contact />
          <Footer />
          <FooterBottom />
        </div>
        <ScrollToTop />
      </div>
    </ThemeProvider>
  );
}

export default App;
